// The only tags the BBCode formatter parses. Shared so text interpolated into a
// translated string can be stripped of anything that would parse as one, while a
// name like "Mailchimp [All Requests]" is left alone.
export const ALLOWED_BBCODE_TAGS = [
    'b',
    'i',
    'u',
    's',
    'url',
    'img',
    'quote',
    'code',
    'style',
    'list',
    '*',
    'function',
    'html',
    'component',
    'br',
    'li',
    'ol',
];

// Matches an opening or closing tag of any allowed name, with its attributes. The
// name has to end where a tag can end — whitespace, `=` or the closing bracket — so
// `[*]` counts (a word boundary would not) while `[bold]` does not. Built from the
// list above, which is why the rule about dynamic patterns does not apply.
// eslint-disable-next-line security/detect-non-literal-regexp
export const BBCODE_TAG_PATTERN = new RegExp(
    `\\[/?(?:${ALLOWED_BBCODE_TAGS.map(tag => tag.replace('*', '\\*')).join('|')})(?=[\\s=\\]])[^\\]]*]`,
    'gi'
);

// Text that must not be read as markup when it lands in a translated string.
export const stripBBCodeTags = value => String(value).replace(BBCODE_TAG_PATTERN, '');
